import React, { useState, useEffect, useRef } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import {
  cancelTask,
  returnTask,
  pentingToReturnTask,
  getTask,
  pauseQueueTask,
  resumeQueueTask,
} from '../../store/actions';
// SweetAlert
import SweetAlert from 'react-bootstrap-sweetalert';
import { taskStatusBack } from '../../constants/task_fields';

const TaskActionButton = function (props) {
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertPendingToReturn, setShowAlertPendingToReturn] = useState(false);
  const [showAlertInboundArea, setshowAlertInboundArea] = useState(false);
  const [showNestedAlert, setshowNestedAlert] = useState(false);

  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // ➔ Estado local para saber si esta fila concreta inició una acción
  const [isCurrentTaskProcessing, setIsCurrentTaskProcessing] = useState(false);

  // ➔ Referencias para rastrear el estado previo de carga
  const prevLoadingReturn = useRef(false);
  const prevLoadingCancel = useRef(false);

  // ➔ Escuchar errores de DEVOLVER TAREA (Solo si estuvo cargando y ya terminó)
  useEffect(() => {
    if (prevLoadingReturn.current && !props.loadingReturnTask && isCurrentTaskProcessing) {
      if (props.registrationTaskError) {
        const msg =
          typeof props.registrationTaskError === 'string'
            ? props.registrationTaskError
            : props.registrationTaskError.error || props.registrationTaskError.message || 'Error inesperado';

        setErrorMessage(msg);
        setShowErrorAlert(true);
      }
      setIsCurrentTaskProcessing(false);
    }
    prevLoadingReturn.current = props.loadingReturnTask;
  }, [props.loadingReturnTask, props.registrationTaskError, isCurrentTaskProcessing]);

  // ➔ Escuchar errores de CANCELAR TAREA (Solo si estuvo cargando y ya terminó)
  useEffect(() => {
    if (prevLoadingCancel.current && !props.loadingDeleteTask && isCurrentTaskProcessing) {
      if (props.cancelTaskError) {
        const msg =
          typeof props.cancelTaskError === 'string'
            ? props.cancelTaskError
            : props.cancelTaskError.error || props.cancelTaskError.message || 'Error al cancelar la tarea';

        setErrorMessage(msg);
        setShowErrorAlert(true);
      }
      setIsCurrentTaskProcessing(false);
    }
    prevLoadingCancel.current = props.loadingDeleteTask;
  }, [props.loadingDeleteTask, props.cancelTaskError, isCurrentTaskProcessing]);

  // ➔ Cerrar popup de error y limpiar errores en Redux
  const handleCloseErrorAlert = () => {
    setShowErrorAlert(false);
    setErrorMessage('');
    setIsCurrentTaskProcessing(false);
    if (props.clearTaskErrors) {
      props.clearTaskErrors();
    }
  };

  let task = props.task;
  let user = JSON.parse(localStorage.getItem('authUser'));

  let returnTask = (task, response) => {
    if (props.clearTaskErrors) props.clearTaskErrors();
    setShowErrorAlert(false);
    setIsCurrentTaskProcessing(true);
    props.returnTask(task, user, props.history, response);
    setshowAlertInboundArea(false);
  };

  let askForInboundShow = (event) => {
    event.preventDefault();
    setshowAlertInboundArea(true);
  };

  let askForInboundHide = () => {
    setshowAlertInboundArea(false);
  };

  let updateTask = (event, task) => {
    event.preventDefault();
    props.history.push({
      pathname: '/updateTask',
      query: { task: task, page_origin: props.page_origin },
    });
  };

  let cancelTask = () => {
    if (props.clearTaskErrors) props.clearTaskErrors();
    setShowErrorAlert(false);
    if (task.sgtTaskStatus < taskStatusBack.EJECUTANDO) {
      setshowNestedAlert(true);
      setShowAlert(false);
    } else {
      setIsCurrentTaskProcessing(true);
      props.cancelTask(task, null, user.token, props.history);
      setShowAlert(false);
    }
  };

  let cancelTask2 = (response) => {
    if (props.clearTaskErrors) props.clearTaskErrors();
    setShowErrorAlert(false);
    setIsCurrentTaskProcessing(true);
    props.cancelTask(task, response, user.token, props.history);
    setshowNestedAlert(false);
  };

  let pauseQueueTask = (event, task) => {
    event.preventDefault();
    props.pauseQueueTask(task, user.token, props.history);
  };

  let resumeQueueTask = (event, task) => {
    event.preventDefault();
    props.resumeQueueTask(task, user.token, props.history);
  };

  const noCancelTask = () => {
    setShowAlert(false);
  };
  const pressButton = (event) => {
    event.preventDefault();
    setShowAlert(true);
  };
  const pendingToReturn = () => {
    props.pentingToReturnTask(task, user.token, props.history);
    props.getTask(user, 100, 1);
    setShowAlertPendingToReturn(false);
  };
  const pendingToReturnTaskShow = (event) => {
    event.preventDefault();
    setShowAlertPendingToReturn(true);
  };

  const noCancelTask2 = () => {
    setshowNestedAlert(false);
  };

  let task_status = parseInt(task.sgtTaskStatus);
  let isPaused = parseInt(task.isPaused);
  let taskType = task.taskType;
  let actions = [];

  const isLoading = (props.loadingReturnTask || props.loadingDeleteTask) && isCurrentTaskProcessing;

  if (showNestedAlert) {
    actions.push(
      <SweetAlert
        input
        showCancel
        type="input"
        placeholder="Pulse 'Ok' para retorno automático"
        title={`Inserte estrategia de entrada`}
        cancelBtnBsStyle="danger"
        confirmBtnBsStyle="success"
        confirmBtnText={props.t('ok')}
        cancelBtnText={props.t('Cancel')}
        onConfirm={(response) => cancelTask2(response)}
        onCancel={() => noCancelTask2()}
        required={false}
      ></SweetAlert>,
    );
  }

  if (task_status > taskStatusBack.FINALIZADA) {
    if (task_status >= taskStatusBack.PENDIENTE_RETORNO) {
      actions.push(
        <Col className="col-md-4" key={'Col' + task.sgtTaskId}>
          <Button
            key={'Cancel' + task.sgtTaskId}
            className="btn btn-danger"
            title={props.t('Cancelar')}
            onClick={(event) => pressButton(event)}
          >
            <i size="lg" className="mdi  mdi-cancel"></i>
          </Button>
          {showAlert && (
            <SweetAlert
              showCancel
              title={`¡Cuidado! usted va a cancelar una tarea que está en ejecución. ¿Está seguro?`}
              cancelBtnBsStyle="danger"
              confirmBtnBsStyle="success"
              confirmBtnText={props.t('ok')}
              cancelBtnText={props.t('Cancel')}
              onConfirm={() => cancelTask()}
              onCancel={() => noCancelTask()}
            ></SweetAlert>
          )}
        </Col>,
      );
      if (task_status === taskStatusBack.PENDIENTE_RETORNO) {
        actions.push(
          <Col key={'ColDevolver' + task.sgtTaskId}>
            <Button
              className="btn btn-primary"
              title={props.t('Devolver')}
              onClick={(event) => askForInboundShow(event)}
            >
              {' '}
              <i size="lg" className="mdi  mdi-redo"></i>
            </Button>
            {showAlertInboundArea && (
              <SweetAlert
                input
                showCancel
                type="input"
                placeholder="Pulse 'Ok' para retorno automático"
                title={`Inserte estrategia de entrada`}
                cancelBtnBsStyle="danger"
                confirmBtnBsStyle="success"
                confirmBtnText={props.t('ok')}
                cancelBtnText={props.t('Cancel')}
                onConfirm={(response) => returnTask(task, response)}
                onCancel={() => askForInboundHide()}
                required={false}
              ></SweetAlert>
            )}
          </Col>,
        );
      }
      if (task_status >= taskStatusBack.COLA && isPaused === 0) {
        actions.push(
          <Col className="col-md-4" key={'ColUpdate' + task.sgtTaskId}>
            <Button
              color="primary"
              title={props.t('Modificar')}
              className="btn btn-primary"
              onClick={(event) => updateTask(event, task)}
            >
              {' '}
              <i size="lg" className="mdi  mdi-pencil"></i>
            </Button>
          </Col>,
        );
        actions.push(
          <Col className="col-md-4" key={'ColPause' + task.sgtTaskId}>
            <Button
              color="secondary"
              title={props.t('Pausar')}
              className="btn btn-primary"
              onClick={(event) => pauseQueueTask(event, task)}
            >
              {' '}
              <i size="lg" className="mdi  mdi-pause"></i>
            </Button>
          </Col>,
        );
      } else if (task_status >= taskStatusBack.COLA && isPaused === 1) {
        actions.push(
          <Col className="col-md-4" key={'ColUpdateP' + task.sgtTaskId}>
            <Button
              color="primary"
              title={props.t('Modificar')}
              className="btn btn-primary"
              onClick={(event) => updateTask(event, task)}
            >
              {' '}
              <i size="lg" className="mdi  mdi-pencil"></i>
            </Button>
          </Col>,
        );
        actions.push(
          <Col className="col-md-4" key={'ColResume' + task.sgtTaskId}>
            <Button
              color="success"
              title={props.t('Reanudar')}
              className="btn btn-primary"
              onClick={(event) => resumeQueueTask(event, task)}
            >
              {' '}
              <i size="lg" className="mdi  mdi-play"></i>
            </Button>
          </Col>,
        );
      }
    }
  }

  if (
    taskType === 'WAIT' &&
    task_status > taskStatusBack.PENDIENTE_RETORNO &&
    task_status <= taskStatusBack.EJECUTANDO
  ) {
    actions.push(
      <Col className="col-md-4" key={'ColWait' + task.sgtTaskId}>
        <Button
          color="primary"
          title={props.t('pendingToReturn')}
          className="btn btn-success"
          onClick={(event) => pendingToReturnTaskShow(event, task)}
        >
          {' '}
          <i size="lg" className="mdi mdi-trending-down"></i>
        </Button>
        {showAlertPendingToReturn && (
          <SweetAlert
            showCancel
            title={props.t('PENDING_TO_RETURN_MESSAGE')}
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={props.t('ok')}
            cancelBtnText={props.t('Cancel')}
            onConfirm={() => pendingToReturn()}
            onCancel={() => setShowAlertPendingToReturn(false)}
          ></SweetAlert>
        )}
      </Col>,
    );
  }

  return (
    <React.Fragment>
      <Row key={task.sgtTaskId}>
        {actions.map((action) => {
          if (action) {
            return action;
          }
          return null;
        })}
      </Row>

      {/* 1. MODAL DE CARGA (LOADER) */}
      {isLoading && (
        <SweetAlert title={props.t('Procesando...')} showConfirm={false} onConfirm={() => {}}>
          <div className="p-3 text-center">
            <div className="spinner-border text-primary m-2" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
            <p className="mt-3 mb-0 text-muted">{props.t('Por favor espere mientras se envía la solicitud')}</p>
          </div>
        </SweetAlert>
      )}

      {/* 2. MODAL DE ERROR */}
      {showErrorAlert && !isLoading && (
        <SweetAlert
          type="error"
          title={props.t('Error')}
          confirmBtnText={props.t('ok')}
          confirmBtnBsStyle="danger"
          onConfirm={handleCloseErrorAlert}
        >
          {errorMessage}
        </SweetAlert>
      )}
    </React.Fragment>
  );
};

const mapStateProps = (state) => {
  const { loadingDeleteTask, cancelTaskError } = state.CancelTask || {};
  const { registrationTaskError, loadingReturnTask } = state.ReturnTask || {};

  return {
    loadingDeleteTask,
    cancelTaskError,
    registrationTaskError,
    loadingReturnTask,
  };
};

const mapDispatchToProps = (dispatch) => ({
  cancelTask: (task, response, token, history) => dispatch(cancelTask(task, response, token, history)),
  returnTask: (task, user, history, response) => dispatch(returnTask(task, user, history, response)),
  pentingToReturnTask: (task, token, history) => dispatch(pentingToReturnTask(task, token, history)),
  getTask: (user, size, page) => dispatch(getTask(user, size, page)),
  // P01021-147bis: el action creator es (task, token, history), sin "event" — pasarlo aquí
  // desajustaba posicionalmente los argumentos (el token real acababa en "history" y el token
  // enviado al backend era el objeto task, de ahí "token invalid" al pausar/reanudar una tarea).
  pauseQueueTask: (task, token, history) => dispatch(pauseQueueTask(task, token, history)),
  resumeQueueTask: (task, token, history) => dispatch(resumeQueueTask(task, token, history)),
  clearTaskErrors: () => {
    dispatch({ type: 'RETURN_TASK_FAILED', payload: null });
    dispatch({ type: 'CANCEL_TASK_FAILED', payload: null });
  },
});

export default withRouter(connect(mapStateProps, mapDispatchToProps)(withNamespaces()(TaskActionButton)));
